import { useCallback, useEffect, useMemo, useState } from "react";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "antd";

import LoadError from "../loadError";
import IconButton from "../iconButton";
import TableHeader from "../tableHeader";
import LoadSkeleton from "../loadSkeleton";

const BaseDataDetail = ({
  data,
  title,
  listPath,
  listTitle,
  headerLeft,
  onDataLoad,
  headerRight,
  errorMessage,
  detailOptions,
  detail: Detail,
}) => {
  const navigate = useNavigate();
  const goBackHeader = useMemo(
    () =>
      listPath && listTitle ? (
        <IconButton
          onClick={() => navigate(listPath)}
          icon={<ArrowLeftOutlined />}
          title={listTitle}
        />
      ) : (
        <></>
      ),
    [listPath, listTitle, navigate]
  );

  const [loading, setLoading] = useState(true);
  const handleDataLoad = useCallback(() => {
    onDataLoad ? onDataLoad(setLoading) : setLoading();
  }, [onDataLoad]);

  useEffect(() => {
    handleDataLoad();
  }, [handleDataLoad]);

  return (
    <Row>
      <Col span={24}>
        <TableHeader
          title={title}
          right={headerRight}
          left={headerLeft || goBackHeader}
        />
      </Col>
      <Col span={24}>
        {loading ? (
          <LoadSkeleton
            colProps={{ sm: 24, xxl: 18 }}
            rowProps={{ type: "flex", justify: "center", gutter: [0, 100] }}
          />
        ) : data === "e" ? (
          <LoadError onClick={handleDataLoad} message={errorMessage} />
        ) : (
          <Detail data={data} {...detailOptions} />
        )}
      </Col>
    </Row>
  );
};

export default BaseDataDetail;
